import { useEffect, useMemo } from 'react';
import Layout from 'components/layout';
import { useRecoilValue } from 'recoil';
import { getUser } from 'hooks/useUser';
import styles from '../style.module.scss';
import AdminView from '../adminView';
import useBreadcrumb from 'hooks/useBreadcrumb';

const ProductsPage = () => {
  const user = useRecoilValue(getUser);
  const { setBreadcrumb } = useBreadcrumb();

  const breadcrumb = useMemo(() => {
    if (user.isAdmin) {
      return [
        {
          title: 'Super admin',
          link: '#',
        },
        {
          title: 'Fatturazione',
          link: '',
        },
      ];
    }

    if (user.isOwner) {
      return [
        {
          title: 'Owner',
          link: '#',
        },
        {
          title: 'Fatturazione',
          link: '',
        },
      ];
    }

    return [
      {
        title: user?.currentShop?.title,
        link: '#',
      },
      {
        title: 'Fatturazione',
        link: '/billing  ',
      },
    ];
  }, [user]);

  useEffect(() => {
    setBreadcrumb(breadcrumb);
  }, [user]);

  return (
    <Layout breadcrumb={breadcrumb}>
      <div className={styles.container}>
        <AdminView isAdmin={user.isAdmin || user.isOwner} />
      </div>
    </Layout>
  );
};

export default ProductsPage;
